import { render, staticRenderFns } from "./EditEmergencyContact.vue?vue&type=template&id=76ce6e6c&scoped=true"
import script from "./EditEmergencyContact.vue?vue&type=script&lang=js"
export * from "./EditEmergencyContact.vue?vue&type=script&lang=js"
import style0 from "./EditEmergencyContact.vue?vue&type=style&index=0&id=76ce6e6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ce6e6c",
  null
  
)

export default component.exports